import BusinessCard from "./BusinessCard";

export default BusinessCard;
